module.exports = __webpack_public_path__ + "img/logo-menu.79af3181.png";